import { render, staticRenderFns } from "./ex-item.vue?vue&type=template&id=19a99650&scoped=true&"
import script from "./ex-item.vue?vue&type=script&lang=js&"
export * from "./ex-item.vue?vue&type=script&lang=js&"
import style0 from "./ex-item.vue?vue&type=style&index=0&id=19a99650&scoped=true&lang=scss&"
import style1 from "./ex-item.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a99650",
  null
  
)

export default component.exports